import React, { useState } from 'react';
import { Divider, FormHelperText, InputAdornment, Tabs, Tab, TextField, Typography, Radio, MuiThemeProvider, createMuiTheme, withStyles, Tooltip, Switch } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import IcDelete from '../../assets/ic_delete.png';
import IcButton from '../../assets/icon_button.png';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import editIcon from '../../assets/1@3x.png';
import { format } from 'date-fns';
import api from '../api';
import { useHistory } from 'react-router-dom';
import { green } from '@material-ui/core/colors';
import Loader from 'react-loader-spinner'
import { isValid } from 'date-fns';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable5());

const options = ct.customOptionsNofilSearch();

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

export default function FindPatient(props) {
    // console.log(props);
    const history = useHistory()
    const classes = useStyles();
    const dispatch = useDispatch();
    const [newPasien, setNewPasien] = useState({
        jenisKelamin: ""
    })
    const [namaPasien, setNamaPasien] = useState("")
    const [noKTP, setNOKTP] = useState("")
    const [bod, setBod] = useState(null)
    const [phone, setPhone] = useState("")
    const [gender, setGender] = useState(null)
    const [alamat, setAlamat] = useState("")
    const [rekamMedis, setRekamMedis] = useState("")
    const [tglLahir, setTglLahir] = useState(new Date());
    const listJenkel = [
        { value: 'Laki-laki', id: 'L' },
        { value: 'Perempuan', id: 'P' },
    ]
    const [asuransiLength, setAsuransiLength] = useState([]);
    const [namaBPJS, setNamaBPJS] = useState("")
    const [noBPJS, setNoBPJS] = useState("")
    const [visibleData, setVisibleData] = useState(false)

    const [namaPengunjung, setNamaPengunjung] = React.useState("Pilih Pengunjung");
    const [textNama, setTextNama] = React.useState("");
    const [errorNama, setErrorNama] = React.useState(false);
    const [textPhone, setTextPhone] = React.useState("");
    const [errorPhone, setErrorPhone] = React.useState(false);
    const [textNoKTP, setTextNoKTP] = React.useState("");
    const [errorNoKTP, setErrorNoKTP] = React.useState(false);
    const [textAlamat, setTextAlamat] = React.useState("");
    const [dataVerified, setDataVerified] = React.useState([]);
    const [dataUnVerified, setDataUnVerified] = React.useState([]);
    const [messageError, setMessageError] = React.useState("")
    const [visibleMessageError, setVisibleMessageError] = React.useState(false)
    const [nama_patient, set_nama_patient] = React.useState("");
    const [medical_record, set_medical_record] = React.useState("");
    const [errorAlamat, setErrorAlamat] = React.useState(false);
    const [errorGender, setErrorGender] = React.useState(false);
    const [selectedPatient, setSelectedPatient] = React.useState([]);
    const [selectedTab, setSelectedTab] = React.useState("Cari Pasien")
    const [error_nama_patient, set_error_nama_patient] = React.useState(false)
    const [error_medical_record, set_error_medical_record] = React.useState(false)
    const [text_nama_patient, set_text_nama_patient] = React.useState(null)
    const [text_medical_record, set_text_medical_record] = React.useState(null)
    const [dataKosong, setDataKosong] = React.useState(false)
    const [nonIntergrasi, setNonIntergrasi] = useState(false)
    const [loading, setLoading] = React.useState(false)



    React.useEffect(() => {
        getParam()
    }, [])

    const getParam = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    response.data.data.map((item) => {
                        if (item.param_code === "INTEGRATION_RESERVATION") {
                            if (item.param_value === "false") {
                                setNonIntergrasi(false)
                            } else {
                                setNonIntergrasi(true)
                            }

                        }
                    })
                }
            }
        })
    }

    const getPatient = () => {
        let nama = nama_patient === "" ? "" : `name=${nama_patient}&`
        let noRM = medical_record === "" ? "" : `mr_no=${medical_record}`
        let dob = bod === null ? "" : `dob=${format(bod, 'yyyy-MM-dd')}`
        let params = bod === null ? `${nama}${noRM}` : `${nama}${dob}`
        let paramNoRM = medical_record === "" ? "" : `medical_record_no=${medical_record}`
        if (bod === null && medical_record === "") {
            setMessageError("pencarian menggunakan kombinasi antara Nama Pasien dan Tanggal Lahir atau Nama Pasien dan No Rekam Medis")
            setVisibleMessageError(true)
            setVisibleData(false)
            setLoading(false)
        } else if (nama === "" && medical_record !== "") {
            api.create().searchPatientIntegrationByNoRM(paramNoRM).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true && response.data.message === "Success!") {
                        let resp = response.data.data
                        let data = []
                        data.push({
                            name: resp.name,
                            rekamMedis: resp.medical_record_no,
                            bod: resp.date_of_birth,
                            ktp: resp.identity_no,
                            hp: resp.phone,
                            mobilePhone: resp.mobile_phone,
                            address: resp.address,
                            status: "Verified",
                            id: resp.id,
                            gender: resp.gender
                        })
                        setDataVerified(data)
                        setVisibleData(true)
                        setLoading(false)

                    } else {
                        setMessageError(response.data.message)
                        setVisibleMessageError(true)
                        setVisibleData(false)
                        setLoading(false)
                    }
                }
            })
        } else {
            api.create().searchPatientIntegration(params).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data) {
                            if (response.data.data.length > 0) {
                                let data = []
                                response.data.data.map((el) => {
                                    data.push({
                                        name: el.name,
                                        rekamMedis: el.medical_record_no,
                                        bod: el.date_of_birth,
                                        ktp: el.identity_no,
                                        hp: el.phone,
                                        mobilePhone: el.mobile_phone,
                                        address: el.address,
                                        status: "Verified",
                                        id: el.id,
                                        gender: el.gender
                                    })
                                })
                                setLoading(false)
                                setDataVerified(data)
                                setVisibleData(true)
                            } else {
                                setMessageError("Data tidak ditemukan")
                                setVisibleMessageError(true)
                                setVisibleData(false)
                                setLoading(false)
                            }
                        } else {
                            setLoading(false)
                            setMessageError(response.data.message)
                            setVisibleMessageError(true)
                            setVisibleData(false)
                        }
                    } else {
                        setLoading(false)
                        setMessageError(response.data.data)
                        setVisibleMessageError(true)
                        setVisibleData(false)
                    }
                }
            })
        }
    }


    const handleSearch = () => {
        console.log("handle cek");
        if (nama_patient.length > 1 || medical_record !== "") {
            setLoading(true)
            getPatient()
            console.log("tes");
        } else {
            setMessageError("Nama Pasien atau No. Rekam Medis wajib diisi")
            setVisibleMessageError(true)
            setVisibleData(false)
            setLoading(false)
            console.log("123");
            // if (nama_patient.length < 2) {
            // } else if (medical_record.length < 2) {
            //     set_error_medical_record(true)
            //     set_text_medical_record('minimal 3 karakter')
            // }
        }
    }
    // console.log(dataVerified);
    // console.log(dataUnVerified);

    const doSubmit = (e) => {
        let regName = /^[a-zA-Z\s]+$/
        let regAlpha = /^[a-zA-Z]+$/
        let regNumber = /^[0-9]+$/
        if (namaPasien === "") {
            setTextNama("Nama Pasien Harus Diisi")
            setErrorNama(true)
        } else if (!regName.test(namaPasien)) {
            setTextNama("Nama Pasien Tidak Boleh Berisi Angka & Karakter")
            setErrorNama(true)
        } else if (noKTP === "") {
            setTextNoKTP("No KTP Harus Diisi")
            setErrorNoKTP(true)
        } else if (!regNumber.test(noKTP)) {
            setTextNoKTP("No KTP Harus Berisi Angka")
            setErrorNoKTP(true)
        } else if (phone === "") {
            setTextPhone("No. Handphone Harus Diisi")
            setErrorPhone(true)
        } else if (!regNumber.test(phone)) {
            setTextPhone("No. Handphone Harus Berisi Angka")
            setErrorPhone(true)
        } else if (gender === null || gender === "") {
            setErrorGender(true)
        } else if (alamat === "") {
            setTextAlamat("Alamat Harus Diisi")
            setErrorAlamat(true)
        } else {
            let asuransi = []
            asuransiLength.map(item => {
                if (asuransiLength.length > 0 && item.nomor !== "") {
                    asuransi.push({
                        "insurance_no": item.nomor,
                        "insurance_name": item.nama
                    })
                }
            })
            let payload = {
                "name": namaPasien,
                "phone": phone,
                "gender": gender,
                "date_of_birth": format(tglLahir, 'yyyy-MM-dd'),
                "identity_no": noKTP,
                "address": alamat,
                "bpjs_no": noBPJS,
                "insurance": asuransi,
                "medical_record_no": rekamMedis
            }
            console.log(JSON.stringify(payload));
            props.createPasien(payload)
            props.onClose()
        }
    }

    const handleClick = ({ rowData }) => {
        let data = {
            name: rowData[1],
            identity_no: rowData[4],
            date_of_birth: rowData[3],
            address: rowData[7],
            medical_record_no: rowData[2],
            gender: rowData[8],
            mobilePhone: rowData[6],
            phone: rowData[5]
        }
        // api.create().getDetailPatient(rowData[rowData.length - 1]).then(response => {
        //     console.log(response.data.data);
        //     if (response.data) {
        // props.data(data)
        //         props.idPasien(response.data.data.id)
        //         // props.dataVerified(temp2)
        props.isFrom !== "detail" && props.flagEdit(rowData[rowData.length - 2])
        props.onClose()
        props.handleFind(data)
        //     }
        // console.log(response.data.data);
        // })
    }

    const handleSimpan = () => {
        api.create().getFormScrenning().then(response => {
            if (response.data.data) {
                history.push({
                    pathname: '/skrining/create-skrining-pasien',
                    name: 'Tambah Skrining Pasien',
                    state: {
                        // rowData,
                        jenisPengunjung: namaPengunjung,
                        data: response.data.data
                    }
                })
            }
        })
    }

    const columns = [
        {
            name: "",
            options: {
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex' }}>
                            <GreenRadio
                                title="Pilih"
                                checked={false}
                                onChange={(e) => null}
                                onClick={() => handleClick(tableMeta)}
                                // value="c"
                                name="radio"
                                style={{ padding: 0 }}
                                inputProps={{ 'aria-label': 'C' }}
                            />
                        </div>
                    )
                }
            }
        },
        {
            name: 'name',
            label: 'Nama Pasien'
        },
        {
            name: 'rekamMedis',
            label: 'No Rekam Medis'
        },
        {
            name: 'bod',
            label: 'Tanggal Lahir'
        },
        {
            name: 'ktp',
            label: 'KTP'
        },
        {
            name: 'hp',
            label: 'No Telepon'
        },
        {
            name: 'mobilePhone',
            label: 'No Handphone'
        },
        {
            name: 'address',
            label: 'Alamat'
        },
        {
            name: 'gender',
            label: 'Gender',
            options: {
                display: false
            }
        },
        {
            name: 'status',
            label: "Status",
            options: {
                customBodyRender: (val, tableMeta) => {
                    // console.log(val);
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        }
    ]

    const listPengujung = [
        { name: "Pasien" },
        { name: "Pengantar" },
        { name: "Pengunjung" },
    ]

    const handleTambah = () => {
        asuransiLength.push({
            nomor: "",
            nama: ""
        })
        console.log(asuransiLength);
        forceUpdate()
    }

    const handleHapus = (index) => {
        asuransiLength.splice(index, 1)
        forceUpdate()
    }

    const handleNamaAsuransi = (val, index) => {
        asuransiLength[index].nama = val
        forceUpdate()
    }

    const handleNomorAsuransi = (val, index) => {
        asuransiLength[index].nomor = val
        forceUpdate()
    }


    const forceUpdate = React.useReducer(bool => !bool)[1];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 2000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div className="App app-popup-show" style={{ zIndex: 1250 }}>
            <div className="popup-content background-white" style={{ borderRadius: 30, margin: 'auto', overflow: 'auto', width: 1000 }}>
                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Cari Pasien</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <form
                    onSubmit={(e) => {
                        e.preventDefault()
                        if (bod && !isValid(bod)) {
                            return
                        } else {
                            handleSearch()
                        }

                    }}>
                    <div style={{ maxHeight: 700, overflow: 'scroll', backgroundColor: '#fff' }}>
                        {loading && (loadingComponent)}
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                            <div className="column-1" style={{ margin: 'auto' }}>
                                {
                                    error_nama_patient ?
                                        <div>
                                            <Typography style={{ color: 'red', fontSize: 12 }}>{text_nama_patient}</Typography>
                                        </div>
                                        : null
                                }
                                <TextField
                                    style={{ width: '100%' }}
                                    id="nama_patient"
                                    name="nama_patient"
                                    label="Nama Pasien"
                                    // error={error_nama_patient}
                                    // helperText={text_nama_patient}
                                    type=""
                                    placeholder={"Input nama pasien"}
                                    value={nama_patient}
                                    onChange={(e) => {
                                        set_error_nama_patient(false)
                                        set_text_nama_patient(null)
                                        setVisibleMessageError(false)
                                        setMessageError("")
                                        set_nama_patient(e.target.value)
                                        setDataKosong(false)
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-2" style={{ marginTop: 8 }}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        clearable
                                        id="bod"
                                        label="Tanggal Lahir"
                                        format="dd/MM/yyyy"
                                        placeholder="dd/MM/yyyy"
                                        defaultValue="Tanggal Lahir"
                                        value={bod}
                                        autoFill={false}
                                        autoComplete="off"
                                        disabled={medical_record !== "" ? true : false}
                                        onChange={(date) => {
                                            setBod(date)
                                            setVisibleMessageError(false)
                                            setMessageError("")
                                            forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 16,
                                                color: '#7e8085',
                                            }
                                        }}
                                        style={{ width: '100%', cursor: 'pointer', marginTop: 0 }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>

                        <div style={{ width: '90%', margin: 'auto' }}>
                            <div className="column-1" style={{ margin: 'auto' }}>
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: !error_nama_patient ? 7 : 30 }}
                                        id="medical_record"
                                        name="medical_record"
                                        label="No Rekam Medis"
                                        placeholder={"input medical record"}
                                        disabled={bod !== null ? true : false}
                                        // error={error_medical_record}
                                        // helperText={text_medical_record}
                                        value={medical_record}
                                        helperText={textNama}
                                        onChange={(e) => {
                                            set_error_nama_patient(false)
                                            set_text_nama_patient(null)
                                            setVisibleMessageError(false)
                                            setMessageError("")
                                            set_medical_record(e.target.value)
                                            setDataKosong(false)
                                            forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {visibleMessageError && (
                            <div style={{ marginTop: 20 }}>
                                <Typography style={{ color: 'red', fontSize: 11, }}>{messageError}</Typography>
                            </div>
                        )}
                        <div className="" style={{ display: 'flex', justifyContent: 'center', marginBottom: 10, }}>
                            <button
                                onClick={() => {
                                    if (isValid(bod)) {
                                        // handleSearch()
                                    }
                                }}
                                style={{ backgroundColor: '#2A9C6C', height: '4vh', borderRadius: '4vh', alignItems: 'center', display: 'grid', cursor: 'pointer', outline: 'none', borderColor: 'transparent', marginTop: 20, padding: '0px 20px' }}>
                                <Typography style={{ color: '#fff', fontSize: '1vw', textAlign: 'center' }}>Cari Pasien </Typography>
                            </button>
                        </div>
                        <div style={{ marginTop: 25, display: 'grid', paddingLeft: 50, paddingRight: 50, borderBottom: '1px solid #ebebeb', width: '87%', margin: 'auto' }}>
                        </div>
                        {visibleData && (
                            <div style={{ marginTop: 40, paddingLeft: 50, paddingRight: 50, marginBottom: 40, height: 316 }}>

                                <Tabs
                                    value={selectedTab}
                                    indicatorColor="primary"
                                    textColor="#2a9c6c"
                                    // onChange={() => handleChange(el)}
                                    aria-label="disabled tabs example"
                                    style={{ outline: 'null', display: 'flex' }}
                                    classes={{ indicator: classes.tabsIndicator }}
                                >
                                    <Tab label={`Cari Pasien`}
                                        onClick={() => setSelectedTab("Cari Pasien")}
                                        style={{ color: selectedTab == "Cari Pasien" ? '#2a9c6c' : 'black', borderBottom: selectedTab == "Cari Pasien" ? '3px solid #2a9c6c' : null, borderBottomWidth: "10%" }}
                                    />
                                    {/* <Tab label={`Cari Referensi Pasien`}
                                            onClick={() => setSelectedTab("Cari Referensi Pasien")}
                                            style={{ color: selectedTab == "Cari Referensi Pasien" ? '#2a9c6c' : 'black', borderBottom: selectedTab == "Cari Referensi Pasien" ? '3px solid #2a9c6c' : null, borderBottomWidth: "10%" }}
                                        // style={{ color: value == el ? '#2a9c6c' : 'black', borderBottom: value == el ? '3px solid #2a9c6c' : null, borderBottomWidth: "10%" }} 
                                        /> */}
                                </Tabs>
                                {
                                    selectedTab === "Cari Pasien" ?
                                        <MuiThemeProvider theme={getMuiTheme()}
                                            style={{ overflow: 'auto' }}
                                        >
                                            <MUIDataTable
                                                data={dataVerified}
                                                columns={columns}
                                                options={options}
                                            />
                                        </MuiThemeProvider>
                                        :
                                        <MuiThemeProvider theme={getMuiTheme()}
                                            style={{ overflow: 'auto' }}
                                        >
                                            <MUIDataTable
                                                data={dataUnVerified}
                                                columns={columns}
                                                options={options}
                                            />
                                        </MuiThemeProvider>
                                }
                            </div>
                        )}
                    </div>
                </form>
                {/* <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div 
                            onClick={(e) => handleSimpan()} 
                            style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} 
                        >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}